export const NAV_ITEMS = ["section1", "section2", "section3"];

export const ACTIVE_STICKY_FOR_DESKTOP = 670;
export const ACTIVE_STICKY_FOR_MOBILE = 300;
